import React from 'react';
// import {Link} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles({
  list: {
    width: 300,
  },
  fullList: {
    width: 'auto',
  },
});

export default function SideNavBar() {
  var user = window.user;
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (side, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <a href="#education">
          <ListItem button key="Home">
            <ListItemIcon>
              <i className="material-icons">school</i>
            </ListItemIcon>
            <ListItemText primary="Education" />
          </ListItem>
        </a>
      </List>
      <Divider />
      <List>
        <a href="#projects">
          <ListItem button key="Home">
            <ListItemIcon>
              <i className="material-icons">build</i>
            </ListItemIcon>
            <ListItemText primary="Projects" />
          </ListItem>
        </a>
        <a href="#skills">
          <ListItem button key="Home">
            <ListItemIcon>
              <i className="material-icons">class</i>
            </ListItemIcon>
            <ListItemText primary="Skills" />
          </ListItem>
        </a>
        <a href="#experience">
          <ListItem button key="Home">
            <ListItemIcon>
              <i className="material-icons">work</i>
            </ListItemIcon>
            <ListItemText primary="Experience" />
          </ListItem>
        </a>
      </List>
      
      <Divider/>
      <List>
        <a href="#contact">
          <ListItem button key="Contact">
            <ListItemIcon>
              <i className="material-icons">question_answer</i>
            </ListItemIcon>
            <ListItemText primary="Contact" />
          </ListItem>
        </a>
      </List>
    </div>
  );

  return (
    <div>
      <i className="material-icons" onClick={toggleDrawer('right', true)}>menu</i>
      <SwipeableDrawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer('right', false)}
        onOpen={toggleDrawer('right', true)}
      >
        {sideList('right')}
      </SwipeableDrawer>
    </div>
  );
}